<template>
    <div class="TopBox">
       <div class="leftBox">
           <img v-if="ishome" src="@/assets/logo.png" >
           <img v-if="!ishome"  src="@/assets/logo_1.png" >
       </div>
       <div :class="ishome?'middleBox':'middleBox2'">
           <template v-for="(v,i) in navMenu" >
                <span :key="i" :class=" CurrPath== v.Url ?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLinkAddr(i,v.ID,v.Type,v.Url)">{{v.Name}}</span>
           </template>
            <!-- <span :class=" CurrPath=='/'?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLink('/')">首页</span>
            <span :class=" CurrPath=='/Product'?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLink('/Product')">产品介绍</span>
            <span :class=" CurrPath=='/Trainingsite'?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLink('/Trainingsite')">培训现场</span>
            <span @click="toLink('/ListArt')" :class="CurrPath=='/ListArt'?(ishome?'HomeCurrRouter NewBox2':'CurrRouter NewBox'):(ishome?'NewBox2':'NewBox')" @mousemove="isLook=true" @mouseout="isLook=false">新闻资讯
                <div v-show="isLook" class="NewItemBox">
                    <div @click="toLink('/ListArt?act=1')" >公司资讯</div>
                    <div @click="toLink('/ListArt?act=2')" >产品资讯</div>
                    <div @click="toLink('/ListArt?act=3')" >文件指导</div>
                </div>
            </span>
            <span :class=" CurrPath=='/Recruit'?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLink('/Recruit')">公司招聘</span>
            <span :class=" CurrPath=='/About'?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLink('/About')">关于我们</span>
            <span :class=" CurrPath=='/Remark'?(ishome?'HomeCurrRouter':'CurrRouter'):''" @click="toLink('/Remark')">用户反馈</span> -->
       </div>
        <div class="rightBox">
           <div class="rightInt" v-show="int" :class="ishome?'':''">
              <el-input v-model="IntTxt" style="height:30px" debounce=1000 placeholder="请输入内容" @keyup.enter.native="SearchKey">
                <!-- <el-select v-model="select" slot="prepend">
                    <el-option label="资讯" value="1"></el-option>
                </el-select> -->
                <el-button slot="append" icon="el-icon-search" @click="SearchKey()" ></el-button>
              </el-input>
           </div>
           <span id="Homeicon" @click="int=!int" :class="ishome?'':'BlueIconBox'" v-if="!int">
                <img v-if="ishome" src="@/assets/icon-1.png"/>
                <img v-if="!ishome" src="@/assets/icon-1_2.png"/>
           </span>
       </div>
    </div>
</template>
<script>
import { GetNavColumnsByDid } from '@/requestPub/api'
import merge from 'webpack-merge';
export default {
    props:{
        ishome:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            int:false,
            IntTxt:'',
            isLook:false,
            navMenu:[],
            select:'1'
        }
    },
    computed:{
        CurrPathIndex(){
            return this.$store.state.navMenuIndex;
        },
        CurrPath(){
            return this.$route.path;
        }
    },
    mounted(){
        // 是否是在检索
        if(this.$route.query.keys){
            this.int= true;
            this.IntTxt= this.$route.query.keys;
        }
        //获取本地是否存有按钮菜单
        let Arrs = window.sessionStorage.getItem('navMenu')?JSON.parse(window.sessionStorage.getItem('navMenu')):[];
        if(Arrs.length>0){
            this.navMenu = Arrs;
            return;
        }
        GetNavColumnsByDid({Did:1}).then(res=>{  
           let n = new Array();   
           res.Data.map((item)=>{
               if(item.FID == 0){
                  n.push(item)
               }
           });        
           this.navMenu = this.navMenu.concat(...[
                {Name:'首页',Type:-1,Url:'/'}
           ]).concat(...n);
           window.sessionStorage.setItem('navMenu',JSON.stringify(this.navMenu))
        })
    },
    methods:{
        SearchKey(){
            if(!this.IntTxt){
                return  this.$message({
                    message: '请输入关键词',
                    type: 'warning'
                 });
             this.$router.replace({
                query: merge(this.$route.query, {
                    'keys': '',
                })
             });
              this.int = false; 
                 
            }
          
            if(this.$route.path == '/SearchRet'){
                this.$emit('ChangeKeys',this.IntTxt)
            }else{
                  this.$router.push('/SearchRet?isSearchRet=true&keys='+this.IntTxt);
            }
            // let Addrs = '';
            // if(this.select =='1'){
            //      Addrs = '/ListArt?id=4&keys='+this.IntTxt;
            // }
            // if(this.$route.path == '/ListArt'){
            //     this.$emit('isSearch',this.IntTxt);
            // }else{
            //   this.$router.push(Addrs)
            // }
        },
        toLinkAddr(nidx,ids,types,urls){            
            if(this.$route.path  == urls) return window.location.reload();
            window.sessionStorage.setItem('UpNavIndex',nidx);
            this.$store.commit('UpNavIndex');
            switch (urls) {
                case '/':
                      this.$router.push(urls)
                    break;
                default:
                      this.$router.push(urls+'?id='+ids+'&types='+types)
                    break;
            }
        },
        toLink(n){
            if(this.$route.path != n){
               this.$router.push(n)
            }   
        }
    }
}
</script>
<style lang="scss">
  .el-select .el-input {
    width:80px;
  }
  .input-with-select .el-input-group__prepend {
    background-color:transparent;
    border: 0;
  }
  .el-input-group__append, .el-input-group__prepend{
      border: 0;
  }
.TopBox{
    height:60px;
    display: inline-flex;
    align-items: center;
    width:100%;
    .leftBox{
         img{
             height: 25px;
         }
    }
    .NewBox2{
        position: relative;
        .NewItemBox{
            position:absolute;
            padding:5px;
            margin-left: -5px;
            width: calc(100% + 5px);
            top:59px;
            background:#4160ce;
            z-index: 99999;
            div{
            font-size: 13px;
             border-bottom: 2px solid transparent;
            line-height: 30px;
            &:hover{
                 cursor: pointer;
                 border-bottom: 2px solid rgba(255, 255,255, .6);
                }
            }
        }
    } 
    .NewBox{
        position: relative;
        .NewItemBox{
            position:absolute;
            padding:5px;
            margin-left: -5px;
            width: calc(100% + 5px);
            top:59px;
            background:#fff;
            z-index: 99999;
            div{
            font-size: 13px;
             border-bottom: 2px solid transparent;
            line-height: 30px;
            &:hover{
                 cursor: pointer;
               border-bottom: 2px solid rgba(65, 96, 206, .6);
            }
            }
        }
    }  
    .CurrRouter{
         border-bottom: 2px solid rgba(65, 96, 206, .6)!important;
    }
    .HomeCurrRouter{
         border-bottom: 2px solid rgba(255, 255, 255, .6)!important;
    }
    // 1
    .middleBox{
        flex:1;
        span{
            display: inline-block;
            line-height: 60px;
            height: 57px;
            color:#fff;
            margin:0 15px;
            font-size: 13px;
            font-weight: 450;
            border-bottom: 2px solid transparent;
            &:hover{
                cursor: pointer;
                border-bottom: 2px solid rgba($color: #fff, $alpha: .6);
            }
        }
    }
    // 2
    .middleBox2{
       flex:1;
        span{
            display: inline-block;
            line-height: 60px;
            height: 57px;
            color:#333;
            margin:0 15px;
            font-size: 13px;
            font-weight: 450;
            border-bottom: 2px solid transparent;
            &:hover{
                cursor: pointer;
                border-bottom: 2px solid rgba(65, 96, 206, .6);
            }
        }
    }
    .rightBox{
        display:inline-flex;
        .rightInt{
            width:240px;
            // background: pink;
            overflow: hidden;
            border-radius: 15px;
            .el-input-group__append{
                padding:0 10px;
            }
            .el-input-group{
                background: transparent;
            }
            .el-input{
                height: 100%;
              .el-input__inner{    
                padding:0 10px;
                padding-right:0;
                border: 0;;
                height: 30px;
                outline: none;
                line-height: 30px;
                background:#F5F7FA;
                border-radius: 0;
               }
            }
        }
        #Homeicon{
            margin-left:15px ;
            display:inline-flex;
            width:28px;
            height: 28px;
            border-radius: 50%;
            align-items: center;
            border:1px solid #fff;
            img{
                width: 13px;
                margin:0 auto;
                height: 15px;
            }
            &:hover{
                cursor: pointer;
            }
        }
        .BlueIconBox{
             border:1px solid #4160ce!important;
        }
    }
}

</style>